import type { FaireProductEntity } from "../../entity_types/product";

export const p_m67ub353ws: FaireProductEntity = {
  token: "p_m67ub353ws",
  type: "product",
  name: "Duea Olive Wood Pocket Prayer Cross *",
  brandToken: "b_42bfa9c9",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/99e96a2e7d34036216aaeb3cbe8a8032ab2107f07de3bd960157c041a3e3b50b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/550d972351a6584fc181a7ec5004415620521ea387d2f1d0c6d9de4a4dbf7ffa.jpeg",
    "https://cdn.faire.com/fastly/260b42f44e2042d1e3c79dd5cf82651bd298b702c3e718171a6b8e8d51a0fe9c.jpeg",
    "https://cdn.faire.com/fastly/91a62dbece53c916149c4564add3eb2bc53e1bad081c543cbedd76e9ea97a7e5.jpeg",
    "https://cdn.faire.com/fastly/b1c6a457ff714fa2178b3f8d52962bb888dc1ea15a43e184d560e3cbd9a033ba.jpeg",
    "https://cdn.faire.com/fastly/8aeceae8bc4288589672b28a91ac5d50ea588a5cf973aeacd3ea8b7ff30177f4.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "The Duea Olive Wood Pocket Prayer Cross is hand carved from sustainably harvested olive wood and made with high-quality artisan craftsmanship. Featuring a unique thumb groove design for improved concentration and calming effects, it's the perfect portable stress-relief companion. Find comfort in the natural beauty of this eco-friendly alternative to plastic fidget toys.\n\n* Available only in the US. - Materials: Olive wood - Includes a card attached with string to the top of the cross - Measures: 2.5\"H - Barcode: 732919546675 - Colors: Natural - Handcrafted in the West Bank",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.242Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
